module.exports = __webpack_public_path__ + "img/1.05.thmb.b5eae2dc.jpg";